"use client";
import { useAuth } from "@/lib/Authentication/hooks/useAuth";
import { useCartData } from "@/lib/cartData/useCartData";
import { datadogRum } from "@datadog/browser-rum";
import { parseCookies } from "nookies";
import { useEffect } from "react";
datadogRum.init({
  applicationId: "8bdd1c14-c4ee-400d-950a-ec8ff46a93d6",
  clientToken: "pubc1a384701766846620006661aa2e6f06",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "us5.datadoghq.com",
  service: "wuilt-storefront",
  env: process.env.NEXT_PUBLIC_NODE_ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: process.env.NODE_ENV === "development" ? 0 : 100,
  sessionReplaySampleRate: process.env.NODE_ENV === "development" ? 0 : 100,
  defaultPrivacyLevel: "allow",
});
const DataDogInstallation = () => {
  const { user: customer } = useAuth();
  const { cart } = useCartData();
  const { sessionId } = parseCookies();
  useEffect(() => {
    if (!customer && !sessionId && !cart.customer && !cart.contactInfo) return;

    datadogRum.setUser({
      id: customer?.id ?? cart?.customer?.id ?? sessionId,
      email:
        customer?.email ??
        cart?.customer?.email ??
        cart?.contactInfo?.email ??
        undefined,
      name:
        customer?.name ??
        cart?.customer?.name ??
        cart?.contactInfo?.name ??
        undefined,
      phone:
        customer?.phone ??
        cart?.customer?.phone ??
        cart?.contactInfo?.phone ??
        undefined,
    });
  }, [customer, sessionId, cart.customer, cart.contactInfo]);
  return null;
};

export default DataDogInstallation;
